
const NavbarItems = [
  {
    label: 'Home',
    url: '/',
    signIn: false,
  },
  {
    label: 'About Us',
    url: '/about-us',
    signIn: false,
  },
  {
    label: 'Shop',
    url: '/shop',
    signIn: false,
  },
  {
    label: 'Add Product',
    url: '/add-product',
    signIn: true,
  },
  {
    label: 'Contact Us',
    url: '/contact-us',
    signIn: false,
  },
];

export default NavbarItems;
